import { AppShell } from "@/components/layout/AppShell";
import { useRequireRole } from "@/lib/auth/useRequireRole";

export function RootLayout() {
  // All app routes require an authenticated session.
  useRequireRole({});
  return <AppShell />;
}
